export const CLOSE_PRODUCT_SIDEBAR_EVENT = "moneytor:close-product-sidebar";

export function notifyCloseProductSidebar() {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new Event(CLOSE_PRODUCT_SIDEBAR_EVENT));
}
